import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex mb-3" }
const _hoisted_4 = { class: "d-flex justify-end" }

import {ref} from "vue";
import {ApiMap} from "@/api/type";
import store from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubmitPropOne',
  props: {
    team: {},
    list: {}
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const tempProposerTeamId = ref<number>(props.team.proposerTeamId)
const tempInvolvedTeamIds = ref<Array<number> | null>(null)
const tempScore = ref<string>('')

function handleEdit() {
  try {
    const scoreList = tempScore.value.split(',').map(Number)
    let temp = 0
    scoreList.forEach((score: number) => {temp += score})
    if (!tempInvolvedTeamIds.value || !tempProposerTeamId.value || tempScore.value === '') {
      store.dispatch('snackBarModule/showError', '请正确填写数据')
      return
    }
    if (temp !== 28) {
      store.dispatch('snackBarModule/showError', '分值之和不为28')
      return
    }
    if (scoreList.length !== tempInvolvedTeamIds.value.length) {
      store.dispatch('snackBarModule/showError', '分值与参与小组不匹配')
      return
    }
    emits('submit',{id: tempProposerTeamId.value, ids: tempInvolvedTeamIds.value, score: scoreList })
    tempInvolvedTeamIds.value = null
    tempScore.value = ''
    emits('close')
  } catch {
    store.dispatch('snackBarModule/showError', '请正确填写数据')
    return
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "pa-8",
    width: "500"
  }, {
    default: _withCtx(() => [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mb-6 text-h6" }, "添加提案", -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "mt-1",
          style: {"width":"150px"}
        }, "提出提案的小组", -1)),
        _createVNode(_component_v_select, {
          disabled: "",
          modelValue: tempProposerTeamId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tempProposerTeamId).value = $event)),
          items: _ctx.list ? _ctx.list : [],
          density: "compact",
          "item-title": (item) => item.teamId ? `第 ${item.teamId} 组` : null,
          "item-value": "teamId",
          placeholder: "请选择提出提案的小组",
          variant: "outlined"
        }, null, 8, ["modelValue", "items", "item-title"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "mt-1",
          style: {"width":"150px"}
        }, "参与游戏的小组", -1)),
        _createVNode(_component_v_select, {
          modelValue: tempInvolvedTeamIds.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tempInvolvedTeamIds).value = $event)),
          items: _ctx.list ? _ctx.list : [],
          density: "compact",
          "item-title": (item) => item.teamId ? `第 ${item.teamId} 组` : null,
          "item-value": "teamId",
          placeholder: "请选择参与提案的小组",
          multiple: "",
          variant: "outlined"
        }, null, 8, ["modelValue", "items", "item-title"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "mt-1",
          style: {"width":"150px"}
        }, "分值分配", -1)),
        _createVNode(_component_v_text_field, {
          placeholder: "请依次填入分值分配",
          modelValue: tempScore.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tempScore).value = $event)),
          variant: "outlined",
          density: "compact",
          hint: "分值之间请使用英文逗号分隔开"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_btn, {
          class: "mr-4",
          color: "primary",
          onClick: handleEdit
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("确认")
          ])),
          _: 1,
          __: [7]
        }),
        _createVNode(_component_v_btn, {
          color: "red-lighten-2",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("取消")
          ])),
          _: 1,
          __: [8]
        })
      ])
    ]),
    _: 1,
    __: [9]
  }))
}
}

})